module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Globe-f8bfb2d3d896d8585b0268b82513412388ab7867a6014cf645988e08ee91c049.svg";